<template>
  <div class="projectMembersPopover" v-loading="loading">
    <div class="top">
      <p>
        项目成员
        <span class="num">{{ num }}</span>
      </p>
      <div class="btn-active tag" @click="openTag" v-if="addOrDelPermission"><i class="icon iconfont iconicon_tag"></i>标签管理</div>
    </div>
    <div class="operator">
      <el-input placeholder="搜索项目成员" v-model="keywords" @input="handleSearch" clearable>
        <i slot="prefix" class="icon iconfont iconicon_search1"></i>
      </el-input>
      <el-popover trigger="click" v-model="visible" v-if="addOrDelPermission && !isDisabledProject">
        <ParticipantList v-if="visible" v-model="taskMemberlistSelect" @confirm="handleConfirm" @close="handleClose" :membersUidArr="membersUidArr"></ParticipantList>
        <div class="add-btn" slot="reference">
          <i class="icon iconfont iconicon_enlarge"></i>
        </div>
      </el-popover>
    </div>

    <div class="members-con-wrap">
      <div class="members-con" v-if="Object.keys(membersDataList).length">
        <ul v-for="(value, key) in membersDataList" :key="key">
          <p class="tit">{{ key }}</p>
          <li v-for="item of value" :key="item.uid">
            <Myavatar width="28px" height="28px" fontSize="12px" :imgUrl="item.user_avatar" :userName="item.realname">
            </Myavatar>
            <div class="tag-bx">
              <span> {{ item.realname }}</span>
              <div class="tags" :ref="`tag-bx-${item.uid}`">
                <span v-if="item[userType] === 2" class="tag id-icon admin">管理员</span>
                <span v-if="isTask && item.type === 1" class="tag id-icon creator">创建人</span>
                <span v-if="item.uid === userUid" class="tag id-icon me">本人</span>
                <span class="tag id-icon normal" v-for="(temp) in item.projectMemberHasLabel" :key="temp.label_id">{{temp.label_name}}</span>
                <el-dropdown trigger="click" class="nothing">
                  <i class="icon iconfont iconicon_more_task1 bgActive2"></i>
                  <el-dropdown-menu slot="dropdown" class="project-set-members-operation-dropdown">
                    <el-dropdown-item command="common" v-for="(item) in item.residueData" :key="item.label_id">{{item.label_name}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <el-dropdown v-if="isShowEdit(item) && !isDisabledProject" trigger="click" @command="handleCommand($event, item.uid)" @visible-change="handleVisibleChange($event, item.uid)">
              <div class="icon-wrap activeIconHover">
                <span class="icon" :ref="`icon${item.uid}`"></span>
              </div>
              <el-dropdown-menu slot="dropdown" class="project-set-members-operation-dropdown">
                <el-dropdown-item v-if="setAdminPermission" command="common">
                  普通成员
                  <i v-if="item[userType] !== 1 && item[userType] !== 2" class="icon iconfont iconicon_selected_more_task"></i>
                </el-dropdown-item>
                <el-dropdown-item v-if="setAdminPermission" command="admin">
                  项目管理员
                  <i v-if="item[userType] === 1 || item[userType] === 2" class="icon iconfont iconicon_selected_more_task"></i>
                </el-dropdown-item>
                <span class="line" v-if="setAdminPermission && addOrDelPermission"></span>
                <el-dropdown-item v-if="addOrDelPermission" command="delete" class="delete">移除成员</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
      <nothing v-else :config="{ tip: '暂无此成员', type: 'img_search' }"></nothing>
    </div>
    <TagManage v-model="tagShow" v-if="tagShow" :project_id="id"></TagManage>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
//api
import api from '@/services/api/home/home'
import apiProject from '@/services/api/project/project'
//组件
import ParticipantList from './participantList.vue'
//标签管理
import TagManage from '../tagManage'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // 是否为项目页面引用
    isTask: {
      type: Boolean,
      default: false
    },
    id: {
      // 项目id
      type: Number,
      default: 0
    },
    num: {
      // 成员数量
      type: Number,
      default: 0
    },
    isHide: {
      // 该浮窗是否关闭
      type: Boolean,
      default: false
    },
    membersUidArr: {
      // 成员id组成的数组
      type: Array,
      default: []
    },
    membersDataList: {
      // 成员数据
      type: Object,
      default: {}
    },
    addOrDelPermission: {
      // 增/删成员权限
      type: Boolean,
      default: false
    },
    setAdminPermission: {
      // 设置管理员权限
      type: Boolean,
      default: false
    }
  },
  components: {
    ParticipantList,
    TagManage
  },
  computed: {
    userType() {
      // 返回用户类型字段名
      return this.isTask ? 'type' : 'user_type'
    },
    userUid() {
      // 用户自己的uid
      return JSON.parse(localStorage.getItem('wfUserInfo')).uid
    },
    ...mapState('task/task', {
      isDisabledProject: (state) => state.isDisabledProject
    })
  },
  watch: {
    isHide(val) {
      if (val) {
        if (this.keywords) {
          this.keywords = ''
          this.$emit('handleSearchMember', '', false)
        }
      }
    },
    visible() {
      if (this.visible) {
        this.taskMemberlistSelect = []
      }
    },
    show: {
      handler() {
        if (Object.entries(this.membersDataList).length > 0) {
          this.$nextTick(() => {
            this.addEllipsisForMultiline()
          })
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      keywords: '',
      taskMemberlistSelect: [],
      visible: false,
      tagShow: false,
      loading: false,
      residueData: []
    }
  },
  methods: {


    // 获取有员工的数据
    getFinalData(data) {
      return data.map((item) => {
        if ('uid' in item) {
          return item
        }
        if (item?.children.length) {
          return getFinalData(item.children)
        }
      })
    },
    //搜索
    handleSearch() {
      this.debounce(() => {
        this.$emit('handleSearchMember', this.keywords)
      }, 500)
    },
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(fn, wait)
    },
    async handleCommand(command, id) {
      if (command === 'admin') {
        //设置成管理员
        this.handleSetAdmin(id)
      } else if (command === 'common') {
        // 设置为普通成员
        if (!this.isTask) return
        this.handleSetAdmin(id, 'common')
      } else if (command === 'delete') {
        //删除成员
        this.handleDelete(id)
      }
    },
    // 点击展示下拉菜单的时候，icon加类名以此来做翻转效果
    handleVisibleChange(val, id) {
      this.$refs[`icon${id}`][0].className = val ? 'icon show' : 'icon'
      // console.log(this.$refs[`icon${id}`], 111)
    },
    async handleSetAdmin(id, type) {
      let _msg, _api, param
      if (this.isTask) {
        if (type) {
          // 设置为普通成员
          _msg = '确认设置其为普通成员？'
          _api = apiProject.updateprojectmemberrole
          param = {
            project_id: this.id,
            uid: id,
            type: '0'
          }
        } else {
          _msg = '确认设置其为管理员？'
          _api = apiProject.updateprojectmemberrole
          param = {
            project_id: this.id,
            uid: id,
            type: '2'
          }
        }
      } else {
        _msg = '确认更换此跨团队项目管理员？'
        _api = api.setCrossProjectsAdmin
        param = {
          id: this.id,
          member_admin: id
        }
      }
      this.$wfAlert('', _msg, '', '确定')
        .then(async () => {
          const res = await _api(param)
          if (res) {
            this.$message({
              message: '设置管理员成功',
              type: 'success'
            })
            this.$emit('handleSearchMember', '', false)
          }
        })
        .catch(() => {
          console.log('执行异常')
          next(false)
        })
    },
    async handleDelete(id) {
      let _msg, _api, param
      if (this.isTask) {
        _msg = '被移除的成员将不能再访问此项目。但该成员在项目内的相关信息不会被删除。'
        _api = apiProject.deleteProjectMember
        param = {
          project_id: this.id,
          member: [id]
        }
      } else {
        _msg = '注意：该成员将同时被移出其所在的子项目。'
        _api = api.delCrossProjectsMember
        param = {
          id: this.id,
          project_members: [id]
        }
      }
      this.$wfAlert('warning', '确认移除该成员?', _msg, '移除成员', 'warning')
        .then(async () => {
          const res = await _api(param)
          if (res) {
            this.$message({
              message: '已成功移除该成员',
              type: 'success'
            })
            this.$emit('handleSearchMember', '', true)
          }
        })
        .catch(() => {
          console.log('执行异常')
          next(false)
        })
    },
    // 添加新成员
    async handleConfirm(val) {
      let _api, param
      if (this.isTask) {
        _api = apiProject.updateProjectMember
        const member = val.reduce((cur, item) => {
          cur.push({
            uid: item,
            type: 0
          })
          return cur
        }, [])
        param = {
          project_id: this.id,
          member
        }
      } else {
        _api = api.addCrossProjectsMember
        param = {
          id: this.id,
          project_members: val
        }
      }
      const res = await _api(param)
      if (res) {
        this.$message({
          message: '添加成员成功',
          type: 'success'
        })
        this.$emit('handleSearchMember', '', true)
        this.visible = false
      }
    },
    // 添加成员弹框关闭
    handleClose() {
      this.visible = false
    },
    // 判断是否有操作成员的权限
    isShowEdit(item) {
      let _bol = true
      if (this.isTask && item.type === 1) {
        // 目标为创建者，判断用户是否为创建者
        _bol = item.uid === this.userUid
      } else {
        // 不是创建者，判断是否有权限
        _bol = this.setAdminPermission || this.addOrDelPermission
      }
      return _bol
    },
    openTag() {
      this.tagShow = true
    },
    addEllipsisForMultiline(containerSelector) {
      this.loading = true
      for (let key in this.membersDataList) {
        this.membersDataList[key].forEach(res => {
          let tagParent = this.$refs[`tag-bx-${res.uid}`]
          for (let i = 0; i < tagParent.length; i++) {
            const tags = tagParent[i].querySelectorAll('.tag')
            const notChild = tagParent[i].lastElementChild
            notChild.style.display = 'none'
            const maxHeight = 77
            for (let j = 0; j < tags.length; j++) {
              const tagHeight = tags[j].offsetTop
              // console.log(tagHeight)
              if (tagHeight > maxHeight) {
                // console.log(tagParent[i],tags[j] )
                notChild.style.display = 'block'
                tagParent[i].removeChild(tags[j])
              }
            }
            const newTags = tagParent[i].querySelectorAll('.tag')
            const lastChild = newTags[newTags.length - 1]
            if (notChild.offsetTop > maxHeight) {
              tagParent[i].removeChild(lastChild)
              notChild.style.display = 'block'
            }
            const nowTags = tagParent[i].querySelectorAll('.tag')
            this.$set(res, 'residueData', res.projectMemberHasLabel.slice(nowTags.length, res.projectMemberHasLabel.length))
          }
        })
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
.projectMembersPopover {
  width: 400px;
  height: 672px;
  border-radius: 4px;
  padding: 16px 0 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .top {
    font-size: 16px;
    font-weight: 500;
    color: #0d1f3c;
    line-height: 20px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .num {
      font-size: 14px;
      font-weight: 400;
      color: rgba(13, 31, 60, 0.6);
      margin-left: 8px;
    }
    .tag {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
      i {
        margin-right: 4px;
      }
    }
  }
  .operator {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    margin: 24px 0 4px;
    .el-input__prefix {
      line-height: 32px;
      left: 16px;
    }
    .el-input__suffix {
      .el-input__icon {
        // line-height: 40px;
      }
    }
    .el-input {
      flex: 1;
      width: 0;
      input {
        height: 32px;
        padding-left: 38px;
        background: rgba(32, 32, 32, 0.04);
      }
    }
    .add-btn {
      cursor: pointer;
      width: 32px;
      height: 32px;
      background: linear-gradient(225deg, #1998f1 0%, #0d70e8 100%);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 8px;
      &:hover {
        background: linear-gradient(225deg, #2fa9ff 0%, #1278eb 100%);
      }
      &:active {
        background: linear-gradient(225deg, #026ed8 0%, #0155ba 100%);
      }
      i {
        font-size: 13px;
        color: #fff;
      }
    }
  }
  .members-con-wrap {
    position: relative;
    flex: 1;
    height: 0;
  }
  .members-con {
    max-height: 100%;
    overflow-y: scroll;
    ul {
      .tit {
        font-size: 14px;
        color: rgba(13, 31, 60, 0.6);
        margin: 12px 0 8px 24px;
      }
      li {
        min-height: 40px;
        padding: 6px 8px;
        margin: 0 24px;
        padding-right: 37px;
        border-radius: 4px;
        box-sizing: border-box;
        display: flex;
        align-items: flex-start;
        cursor: pointer;
        position: relative;
        &:hover {
          background: #F5F5F5;
          .icon-wrap {
            visibility: visible;
          }
        }
        &:active {
          background: rgba(32, 32, 32, 0.0428);
        }
        .avatar-box {
          .name-txt {
            margin-left: 16px;
            font-size: 14px;
            color: #0d1f3c;
          }
        }
        .id-icon {
          padding: 6px 6px;
          background: rgba(38, 130, 255, 0.16);
          border-radius: 4px;
          font-size: 12px;
          color: #2682ff;
          line-height: 1;
          &.creator {
            background: rgba(255, 163, 80, 0.16);
            color: #ffa350;
          }
          &.me {
            background: rgba(2, 185, 126, 0.16);
            color: #02b97e;
          }
          &.normal {
            background-color: rgba(32, 32, 32, 0.08);
            color: rgba(32, 32, 32, 0.60);
            max-width: 96px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        &>.el-dropdown {
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          right: 8px;
          top: 50%;
          transform: translate(0, -50%);
        }
        .icon-wrap {
          cursor: pointer;
          padding: 8px;
          visibility: hidden;
          // &:hover {
          //   .icon {
          //     border-top: 6px solid rgba(38, 130, 255, 1);
          //   }
          // }
          // &:active {
          //   .icon {
          //     border-top: 6px solid rgba(38, 130, 255, .6);
          //   }
          // }
          .icon {
            display: block;
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 6px solid rgba(13, 31, 60, 0.4);
            transition: transform 0.3s;
            &.show {
              transform: rotate(180deg);
            }
          }
        }
        .tag-bx {
          display: flex;
          flex-direction: column;
          width: 0;
          flex: 1;
          padding-top: 5px;
          margin-left: 16px;
        }
        .tags {
          display: flex;
          flex-wrap: wrap;
          gap: 4px;
          padding-top: 4px;
          .nothing {
            display: none;
            i {
              padding: 6px 6px;
              border-radius: 4px;
              font-size: 12px;
              line-height: 1;
              background-color: rgba(32, 32, 32, 0.08);
              color: rgba(32, 32, 32, 0.60);
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  .nothing-box {
    img {
      width: 123px;
    }
  }
}
.project-set-members-operation-dropdown {
  .el-dropdown-menu__item {
    position: relative;
    width: 132px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    &.chos {
      color: #2682ff;
      &::after {
        box-sizing: content-box;
        content: '';
        border: 1px solid #2682ff;
        border-left: 0;
        border-top: 0;
        width: 4px;
        height: 8px;
        position: absolute;
        right: 20px;
        top: 14px;
        transform: rotate(45deg) scaleY(1);
        transition: transform 0.15s ease-in 0.05s;
        transform-origin: center;
      }
    }
    i {
      position: absolute;
      right: 17px;
      top: 50%;
      transform: translate(0, -50%);
      margin-right: 0;
      color: #0d70e8;
    }
  }
  .line {
    display: block;
    width: 100%;
    height: 1px;
    background: #e7e9ec;
    margin: 4px 0;
  }
  .delete {
    color: #ff3939;
    &:hover {
      color: #ff3939;
      background: rgba(255, 57, 57, 0.08) !important;
    }
    &:active {
      color: #ff3939 !important;
      background: rgba(255, 57, 57, 0.16) !important;
    }
  }
}
</style>
